<template>
  <el-row>
    <el-col>
      <div class="form-module-tit">{{ $locale('movie.hpDisplay') }}</div>
      <el-form-item :label="$locale('movie.hpRelease')" prop="hpRelease">
        <el-select v-model="formData.hpRelease">
          <el-option v-for="item in booleanOptions" :key="item.label" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
  </el-col>
</el-row>
</template>

<script>
import { booleanOptions } from "@/utils/common";

export default {
  name: "hp-display",
  props: {
    formData: {
      required: true,
      type: Object,
    },
    formRef: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
      booleanOptions,
    };
  },
};
</script>